import { render, staticRenderFns } from "./EocViewSummaryAllergies.vue?vue&type=template&id=d0b93730&scoped=true&"
import script from "./EocViewSummaryAllergies.vue?vue&type=script&lang=js&"
export * from "./EocViewSummaryAllergies.vue?vue&type=script&lang=js&"
import style0 from "./EocViewSummaryAllergies.vue?vue&type=style&index=0&id=d0b93730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b93730",
  null
  
)

export default component.exports